// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListingDetails-showHideBtn-ES44m,
.ListingDetails-showHideBtn-ES44m.ListingDetails-focus-G__Gu,
.ListingDetails-showHideBtn-ES44m:active,
.ListingDetails-showHideBtn-ES44m:hover {
  padding: 0px !important;
  font-weight: 500;
  word-wrap: break-word;
  line-height: 18px;
  letter-spacing: normal;
  font-size: 18px;
  border: 0px !important;
  text-decoration: none !important;
  border-bottom: 1px solid var(--common-link-color) !important;
  color: var(--common-link-color) !important;
}

.ListingDetails-streeingImage-m96Kg {
  width: 100%;
  max-width: 18px;
  position: relative;
  top: 4px;
}

.ListingDetails-displayFlex-pzIaz {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
}

.ListingDetails-sectionLink-Np9Qj {
  border: 1px solid var(--btn-primary-bg);
  padding: 10px;
  border-radius: 60px;
}

.ListingDetails-minMaxSection-KKpL9 {
  display: grid;
  grid-template-columns: 50% 50%;
}

.ListingDetails-listItemSection-I6wGP {
  display: inline-block;
  width: 50%;
}

@media screen and (max-width: 767px) {
  .ListingDetails-listItemSection-I6wGP {
    width: 100%;
  }

  .ListingDetails-minMaxSection-KKpL9 {
    grid-template-columns: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ViewListing/ListingDetails/ListingDetails.css"],"names":[],"mappings":"AAAA;;;;EAIE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;EAChC,4DAA4D;EAC5D,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,uCAAuC;EACvC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":[".showHideBtn,\n.showHideBtn.focus,\n.showHideBtn:active,\n.showHideBtn:hover {\n  padding: 0px !important;\n  font-weight: 500;\n  word-wrap: break-word;\n  line-height: 18px;\n  letter-spacing: normal;\n  font-size: 18px;\n  border: 0px !important;\n  text-decoration: none !important;\n  border-bottom: 1px solid var(--common-link-color) !important;\n  color: var(--common-link-color) !important;\n}\n\n.streeingImage {\n  width: 100%;\n  max-width: 18px;\n  position: relative;\n  top: 4px;\n}\n\n.displayFlex {\n  display: flex;\n  align-items: flex-start;\n}\n\n.sectionLink {\n  border: 1px solid var(--btn-primary-bg);\n  padding: 10px;\n  border-radius: 60px;\n}\n\n.minMaxSection {\n  display: grid;\n  grid-template-columns: 50% 50%;\n}\n\n.listItemSection {\n  display: inline-block;\n  width: 50%;\n}\n\n@media screen and (max-width: 767px) {\n  .listItemSection {\n    width: 100%;\n  }\n\n  .minMaxSection {\n    grid-template-columns: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showHideBtn": `ListingDetails-showHideBtn-ES44m`,
	"focus": `ListingDetails-focus-G__Gu`,
	"streeingImage": `ListingDetails-streeingImage-m96Kg`,
	"displayFlex": `ListingDetails-displayFlex-pzIaz`,
	"sectionLink": `ListingDetails-sectionLink-Np9Qj`,
	"minMaxSection": `ListingDetails-minMaxSection-KKpL9`,
	"listItemSection": `ListingDetails-listItemSection-I6wGP`
};
module.exports = ___CSS_LOADER_EXPORT___;
